module.exports = window["__sharedAtgPush"];